import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-graph',
    templateUrl: './graph.component.svg',
    styleUrls: ['./graph.component.scss']
})
export class GraphComponent implements OnInit {

    @Input() graphX;
    @Input() graphY;
    @Input() graphMarginExt;
    @Input() graphMarginInt;
    @Input() graphColor : string;
    @Input() graphColorNegatif : string;
    @Input() datas;

    graphNbBars : number;
    barWidth : number;
    max : number;
    array_values;

    constructor() { }

    ngOnInit() {
        this.graphX = parseInt(this.graphX);
        this.graphY = parseInt(this.graphY);
        this.graphMarginExt = parseInt(this.graphMarginExt);
        this.graphMarginInt = parseInt(this.graphMarginInt);
        this.generateSvg();
    }

    ngOnChanges() {
        this.generateSvg();
    }

    generateSvg() {
        if (this.datas) {
            let values:any = Object.entries(this.datas).filter(x => x[0].startsWith('MONTH_VALUE_')).map(x => x[1]);
            
            this.graphNbBars = values.length;
            this.barWidth = (this.graphX - 2 * this.graphMarginExt - (this.graphNbBars - 1) * this.graphMarginInt) / this.graphNbBars;
            this.max = Math.max(...values);
            this.array_values = values.map((x, index) => {
                let barHeight = this.max > 0 ? (this.graphY - 2 * this.graphMarginExt) * x / this.max : 0;
                let negatif = barHeight < 0;
                barHeight = Math.abs(barHeight);
                return {
                    barHeight: barHeight, 
                    negatif: negatif, 
                    x: this.graphMarginExt + index * (this.barWidth + this.graphMarginInt),
                    y: this.graphY - this.graphMarginExt - barHeight,
                };
            });
        }
    }
}
